import etd from '../../../assets/img/icons/etd.png';
import season from '../../../assets/img/icons/season.png';
import billing from '../../../assets/img/icons/billing.png';
import citizenship from '../../../assets/img/icons/naturalization.png';
import immigrant from '../../../assets/img/icons/immigrant.png';
import superAdmin from '../../../assets/img/icons/superAdmin.png';
import passes from '../../../assets/img/icons/passes.png';
import procurement from '../../../assets/img/icons/procurement2.png';
import Sidebar from '../../../shared/components/Sidebar';
import Header from '../../../shared/components/Header';
import { Link } from "react-router-dom";
import { getLoginInfo, getRefreshToken, getRoles } from '../../../shared/utils/storage';
import { useEffect } from "react";
import Lindo from '../../../app/guards/RouteGuard';

function MainDashboard() {
  const { mgambo } = Lindo();
  const Roles = getLoginInfo()?.user?.Roles; //PRIVILEGE: RIO Admin, Super Admin, User

  useEffect(() => {
    mgambo("MbaoKuu");
  }, []);
  const Season = () => {
    window.open("#", "_blank");
  };

  const Billing = () => {
    window.open("#", "_blank");
  };

  const Citizenship = () => {
    window.open("#", "_blank");
  };

  const Migrant = () => {
    window.open("#", "_blank");
  };

  const Isas = () => {
    window.open("#  ", "_blank");
  };

  return (
    <>
      <Header />
      <body className="">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content2">
              <div className="container-fluid">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Main Dashboard</i>
                </h2>
                <div className="row">
                  {Roles?.ETD > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link to="/ETD">
                        <div className="card card-stats">
                          <div className="card-header card-header-warning card-header-icon">
                            <div className="card-icon">
                              <img src={etd} width="90px" height="90px" />
                            </div>
                            <h3 className="card-title">ETD</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">Emergence Travel Document</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.Season > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link>
                        <div className="card card-stats">
                          <div className="card-header card-header-success card-header-icon">
                            <div className="card-icon">
                              <img src={season} width="90px" height="90px" />
                            </div>
                            <h3 className="card-title">SEASON</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">Season Migrant Pass</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.Billing > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link onClick={Billing}>
                        <div className="card card-stats">
                          <div className="card-header card-header-info card-header-icon">
                            <div className="card-icon">
                              <img src={billing} width="90px" height="90px" />
                            </div>
                            <h3 className="card-title">BILLING</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">Billing System</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.Citizenship > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link onClick={Citizenship}>
                        <div className="card card-stats">
                          <div className="card-header card-header-danger card-header-icon">
                            <div className="card-icon">
                              <img
                                src={citizenship}
                                width="90px"
                                height="90px"
                              />
                            </div>
                            <h3 className="card-title">Citizenship</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">Citizenship by Naturalation</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.Immigrant > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link>
                        <div className="card card-stats">
                          <div className="card-header card-header-success card-header-icon">
                            <div className="card-icon">
                              <img src={immigrant} width="90px" height="90px" />
                            </div>
                            <h3 className="card-title">MIGRANT</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">Immigrant Pass</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.Passes > 0 || Roles?.PRIVILEGEID != 0 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link onClick={Isas}>
                        <div className="card card-stats">
                          <div className="card-header card-header-info card-header-icon">
                            <div className="card-icon">
                              <img src={passes} width="90px" height="90px" />
                            </div>
                            <h3 className="card-title">ISAS</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">
                              Imm. Service Automation System
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.PRIVILEGEID == 1 || Roles?.PRIVILEGEID == 2 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link>
                        <div className="card card-stats">
                          <div className="card-header card-header-danger card-header-icon">
                            <div className="card-icon">
                              <img
                                src={procurement}
                                width="90px"
                                height="90px"
                              />
                            </div>
                            <h3 className="card-title">STORES</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">
                              Printing Paper Distribution (Procurement Dept.)
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {Roles?.PRIVILEGEID == 1 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link to="/globaladmin">
                        <div className="card card-stats">
                          <div className="card-header card-header-default card-header-icon">
                            <div className="card-icon">
                              <img
                                src={superAdmin}
                                width="90px"
                                height="90px"
                              />
                            </div>
                            <h3 className="card-title">RIO Admin.</h3>
                          </div>
                          <div className="card-footer">
                            <div className="stats">RIO Administration</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default MainDashboard;
